module.exports = __webpack_public_path__ + "img/10.fb531180.png";